import styled from "styled-components";

export const StyledSpinner = styled.i`
  .fa-spin-custom,
  .glyphicon-spin {
    animation: spin 1000ms infinite linear;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`;